<template>
  <div :class="wrapClass">
    <div
      v-for="tag in tags"
      :key="tag.name"
      :class="form ? 'tw-w-full' : 'tw-flex tw-justify-between'"
    >
      <base-checkbox
        :label="tag.localized || (tag.key ? $t(tag.key) : tag.name)"
        :background="background"
        :disabled="disabled || settingsTags.includes(tag.name.toLowerCase())"
        :model-value="isSelected(tag.name)"
        @input="() => updateFilter({ value: tag.name })"
      />
      <filter-box-exclude
        v-if="filter.excluded && !form"
        :toggled="filter.excluded?.includes(tag.name)"
        :filter="filter"
        @input="
          updateFilter({
            id: filter.id,
            value: tag.name,
            filterIn: false,
          })
        "
      />
    </div>
  </div>
</template>

<script>
import FilterBoxExclude from '@components/List/FilterBoxExclude.vue'
import { getTagOptions } from '@helpers/localizedTags.js'
import { toRefs, inject, ref } from 'vue'

export default {
  components: {
    FilterBoxExclude,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    background: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Boolean,
      default: false,
    },
    wrapClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update'],
  setup(props, { emit }) {
    const { filter } = toRefs(props)
    const settingsTags = inject('settingsTags', ref([]))

    const tags = getTagOptions(filter)

    function isSelected(tag) {
      return filter.value.selected.includes(tag)
    }

    function updateFilter({ value, filterIn }) {
      emit('update', {
        id: filter.value.id,
        value,
        type: filter.value.type,
        filterIn,
      })
    }

    return {
      updateFilter,
      settingsTags,
      isSelected,
      tags,
    }
  },
}
</script>
